<template>
  <div></div>
</template>
<script>
import {IntegrationHandshake} from "@/services/westore/entities/integration-handshake";

export default {
  name: "handshake",
  created() {
    this.handshake()
        .then(url => window.location = url)
        .catch(err => console.log(err));
  },
  methods: {
    async handshake() {
      const data = await IntegrationHandshake.handle(
          this.$route.params.market_place,
          window.location.search
      );

      if ('redirect_url' in data) {
        return Promise.resolve(data.redirect_url)
      }

      return Promise.reject(data)
    }
  }
}
</script>

<style scoped>

</style>